import { useEffect } from 'react';

import { api } from '../../api';
import { AppRoutes } from '../../routes';
import { WixUser, configSelectors } from '../../store';
import { UserAuthData } from '../../types';
import { storage } from '../utils/storage';
import { useAppSelector } from './store';

export const useUser = (): { isLoading: boolean; user?: WixUser | UserAuthData } => {
  const isWix = useAppSelector(configSelectors.isWix);
  const pathname = window.location.pathname;

  const skipFetchingUser =
    isWix ||
    AppRoutes.EMBED.match(pathname) ||
    AppRoutes.USER_WIDGET.match(pathname) ||
    AppRoutes.USER_WIDGET_WIX.match(pathname);

  const standaloneUser = api.useGetUserQuery(undefined, { skip: skipFetchingUser });
  const wixUser = useAppSelector((state) => state.app.wixUser);

  useEffect(() => {
    if (standaloneUser.isError) {
      storage.removeItem('accessToken');
    }
  }, [standaloneUser.isError]);

  return {
    isLoading: isWix ? false : standaloneUser.isLoading,
    user: isWix ? wixUser : standaloneUser.data,
  };
};
